import {type Directive} from 'vue';
import {vue3Debounce} from 'vue-debounce';
import focus from './focus';
import indeterminateCheckbox from './indeterminateCheckbox';
import interact from './interact';
import lightBox from './lightBox';
import search from'./search';
import sort from './sort';
import sticky from './sticky';
import tooltip from './tooltip';
import htmlScript from './htmlScript';
import maxChars from './maxChars';
import toggle from './toggle';

const directives: Record<string, Directive> = {
    focus,
    indeterminateCheckbox,
    interact,
    lightBox,
    search,
    sort,
    sticky,
    tooltip,
    htmlScript,
    maxChars,
    toggle,
    debounce: vue3Debounce({ lock: true }),
};

export default directives;